var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"News"}},[_c('TopCover'),_c('List',{attrs:{"news_data":_vm.news_data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }